import { useMediaQuery } from "react-responsive";
import { Details } from "express-useragent";

type Options = {
  inclusive: boolean;
  orientation: "portrait" | "landscape";
}

type BPConfig = {
  "small-mobile": number;
  mobile: number;
  tablet: number;
  desktop: number;
  "big-desktop": number;
  "big-screen": number;
  "max-screen": number;
};

const breakpoints: BPConfig = {
  "small-mobile": 375,
  mobile: 576,
  tablet: 768,
  desktop: 1024,
  "big-desktop": 1200,
  "big-screen": 1400,
  "max-screen": 1600
};

const defaultWidth = (ua: Pick<Details, "isMobile" | "isTablet">) => {
  if (ua.isMobile && !ua.isTablet) return breakpoints.mobile;
  if (ua.isTablet) return breakpoints.tablet;
  return breakpoints.desktop;
}

export const useMediaQueryDown = (bp: keyof BPConfig, options?: Partial<Options>) =>
  useMediaQuery({ maxWidth: breakpoints[bp], orientation: options?.orientation });

export const useMediaQueryUp = (bp: keyof BPConfig, options?: Partial<Options>) =>
  useMediaQuery({ minWidth: breakpoints[bp], orientation: options?.orientation });

export default defaultWidth;
